import { useQuery, keepPreviousData } from '@tanstack/react-query'
import { getErrorLogs } from '../api/error-logs-admin.api'
import type { ErrorLogFilters } from '../types/error-log'

export function useErrorLogs(filters: ErrorLogFilters) {
  return useQuery({
    queryKey: ['admin', 'error-logs', filters],
    queryFn: () => getErrorLogs(filters),
    placeholderData: keepPreviousData,
  })
}
